@if (spinnerState.loading() || (!form && [Mode.EDIT, Mode.VIEW].includes(mode))) {
} @else {
  <div class="sticky dialog-header flex items-center justify-between gap-2">
    <b class="truncate">{{ title | translate: titleParams }}</b>
    <div class="flex items-center gap-2 shrink-0">
      @if (mode === Mode.VIEW) {
        <p-button
          (click)="goToOPD()"
          [label]="'page.customer.button.vital_signs' | translate"
          class="btn-primary"
          icon="pi pi-plus"
        ></p-button>
      }
      <div class="float-right flex gap-5 items-center">
        @if (mode === Mode.CREATE) {
          <p-button
            (onClick)="onReadCard()"
            [label]="'page.customer.button.read_card_id' | translate"
            icon="pi pi-id-card"
          ></p-button>
        }
        <button (click)="onClose()" class="pi pi-times" style="font-size: 1.25rem"></button>
      </div>
    </div>
  </div>

  <p-tabs [value]="activeTab">
    <p-tablist>
      <p-tab (click)="onTab(0)" value="0">{{ 'page.customer.tab.personal_information' | translate }}</p-tab>
      <p-tab (click)="onTab(1)" value="1">{{ 'page.customer.tab.health_information' | translate }}</p-tab>
      <p-tab (click)="onTab(2)" value="2">{{ 'page.customer.tab.medical_history' | translate }}</p-tab>
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel value="0">
        <form [formGroup]="form">
          <div class="pt-8 pb-10">
            @if (!isEditing) {
              <img
                [src]="form.getRawValue().photo || 'assets/images/no-image.jpg'"
                alt="photo"
                class="image-personal"
              />
            } @else {
              <div
                (change)="onSelect($event)"
                [accept]="'image/*'"
                [ngClass]="{ upload: selectedFiles && selectedFiles.length > 0 }"
                class="custom-dropzone"
                ngx-dropzone
              >
                <ngx-dropzone-label>
                  <div>
                    <b>{{ 'page.customer.upload.label' | translate }}</b>
                  </div>
                </ngx-dropzone-label>
                @if (selectedFiles && selectedFiles.length > 0) {
                  <ngx-dropzone-image-preview
                    (removed)="onRemove()"
                    [file]="selectedFiles[0]"
                    [removable]="true"
                    class="img-preview"
                  ></ngx-dropzone-image-preview>
                }
              </div>
            }
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-8 gap-x-4">
            <div>
              <div class="mb-2">{{ 'page.customer.field.prefix' | translate }}</div>
              @if (isEditing) {
                <input
                  [placeholder]="'page.customer.field.prefix' | translate"
                  autocomplete="off"
                  class="w-full"
                  formControlName="prefix"
                  pInputText
                />
              } @else {
                <div>{{ form.getRawValue().prefix || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.sex' | translate }}</div>
              @if (isEditing) {
                <app-select
                  [placeholder]="'common.label.please_select' | translate"
                  [selectedOption]="sexOptions"
                  [stringTranslate]="'common.options.sex.'"
                  class="w-full"
                  formControlName="sex"
                ></app-select>
              } @else {
                {{ form.getRawValue().sex ? ('common.options.sex.' + form.getRawValue().sex | translate) : '-' }}
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.nationality' | translate }}</div>
              @if (isEditing) {
                <input
                  [placeholder]="'page.customer.field.nationality' | translate"
                  autocomplete="off"
                  class="w-full"
                  formControlName="nationality"
                  pInputText
                />
              } @else {
                <div>{{ form.getRawValue().nationality || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.religion' | translate }}</div>
              @if (isEditing) {
                <input
                  [placeholder]="'page.customer.field.religion' | translate"
                  autocomplete="off"
                  class="w-full"
                  formControlName="religion"
                  pInputText
                />
              } @else {
                <div>{{ form.getRawValue().religion || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.marital_status' | translate }}</div>
              @if (isEditing) {
                <app-select
                  [placeholder]="'common.label.please_select' | translate"
                  [selectedOption]="maritalStatusOptions"
                  [stringTranslate]="'common.options.marital_status.'"
                  class="w-full"
                  formControlName="maritalStatus"
                ></app-select>
              } @else {
                <div>
                  {{
                    form.getRawValue().maritalStatus
                      ? ('common.options.marital_status.' + form.getRawValue().maritalStatus | translate)
                      : '-'
                  }}
                </div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.blood_type' | translate }}</div>
              @if (isEditing) {
                <app-select
                  [placeholder]="'common.label.please_select' | translate"
                  [selectedOption]="bloodTypeOptions"
                  [stringTranslate]="'common.options.blood_type.'"
                  class="w-full"
                  formControlName="bloodType"
                ></app-select>
              } @else {
                <div>
                  {{
                    form.getRawValue().bloodType
                      ? ('common.options.blood_type.' + form.getRawValue().bloodType | translate)
                      : '-'
                  }}
                </div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.birthday' | translate }}</div>
              @if (isEditing) {
                <p-date-picker
                  [placeholder]="'page.customer.field.birthday' | translate"
                  [readonlyInput]="true"
                  class="w-full"
                  dateFormat="dd/mm/yy"
                  formControlName="birthday"
                />
              } @else {
                <div>{{ (form.getRawValue().birthday | date: 'dd/MM/yyyy') || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.id_card_number' | translate }}</div>
              @if (isEditing) {
                <p-input-number
                  [maxlength]="13"
                  [placeholder]="'page.customer.field.id_card_number' | translate"
                  [useGrouping]="false"
                  class="w-full"
                  formControlName="idCardNumber"
                ></p-input-number>
              } @else {
                <div>{{ form.getRawValue().idCardNumber || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.passport' | translate }}</div>
              @if (isEditing) {
                <input
                  [placeholder]="'page.customer.field.passport' | translate"
                  autocomplete="off"
                  class="w-full"
                  formControlName="passport"
                  pInputText
                />
              } @else {
                <div>{{ form.getRawValue().passport || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.name' | translate }}<label class="text-danger">*</label></div>
              @if (isEditing) {
                <input
                  [invalid]="form.get('name')?.invalid && isSubmit"
                  [placeholder]="'page.customer.field.name' | translate"
                  autocomplete="off"
                  class="w-full"
                  formControlName="name"
                  pInputText
                />
              } @else {
                <div>{{ form.getRawValue().name || '-' }}</div>
              }
              @if (form.get('name')?.invalid && isSubmit) {
                <div class="text-danger mt-2">{{ 'common.validation.required' | translate }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.surname' | translate }}</div>
              @if (isEditing) {
                <input
                  [placeholder]="'page.customer.field.surname' | translate"
                  autocomplete="off"
                  class="w-full"
                  formControlName="surname"
                  pInputText
                />
              } @else {
                <div>{{ form.getRawValue().surname || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.nickname' | translate }}</div>
              @if (isEditing) {
                <input
                  [placeholder]="'page.customer.field.nickname' | translate"
                  autocomplete="off"
                  class="w-full"
                  formControlName="nickname"
                  pInputText
                />
              } @else {
                <div>{{ form.getRawValue().nickname || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.name_en' | translate }}</div>
              @if (isEditing) {
                <input
                  [placeholder]="'page.customer.field.name_en' | translate"
                  autocomplete="off"
                  class="w-full"
                  formControlName="nameEN"
                  pInputText
                />
              } @else {
                <div>{{ form.getRawValue().nameEN || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.surname_en' | translate }}</div>
              @if (isEditing) {
                <input
                  [placeholder]="'page.customer.field.surname_en' | translate"
                  autocomplete="off"
                  class="w-full"
                  formControlName="surnameEN"
                  pInputText
                />
              } @else {
                <div>{{ form.getRawValue().surnameEN || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.tel1' | translate }}</div>
              @if (isEditing) {
                <p-input-number
                  [maxlength]="20"
                  [placeholder]="'page.customer.field.tel1' | translate"
                  [useGrouping]="false"
                  class="w-full"
                  formControlName="tel1"
                ></p-input-number>
              } @else {
                <div>{{ form.getRawValue().tel1 || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.tel2' | translate }}</div>
              @if (isEditing) {
                <p-input-number
                  [maxlength]="20"
                  [placeholder]="'page.customer.field.tel2' | translate"
                  [useGrouping]="false"
                  class="w-full"
                  formControlName="tel2"
                ></p-input-number>
              } @else {
                <div>{{ form.getRawValue().tel2 || '-' }}</div>
              }
            </div>

            <p-divider class="col-span-full" />

            <div>
              <div class="mb-2">{{ 'page.customer.field.address' | translate }}</div>
              @if (isEditing) {
                <textarea
                  [placeholder]="'page.customer.field.address' | translate"
                  class="w-full"
                  formControlName="address"
                  pTextarea
                  rows="5"
                ></textarea>
              } @else {
                <div>{{ form.getRawValue().address || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.sub_district' | translate }}</div>
              @if (isEditing) {
                <input
                  [placeholder]="'page.customer.field.sub_district' | translate"
                  autocomplete="off"
                  class="w-full"
                  formControlName="subDistrict"
                  pInputText
                />
              } @else {
                <div>{{ form.getRawValue().subDistrict || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.district' | translate }}</div>
              @if (isEditing) {
                <input
                  [placeholder]="'page.customer.field.district' | translate"
                  autocomplete="off"
                  class="w-full"
                  formControlName="district"
                  pInputText
                />
              } @else {
                <div>{{ form.getRawValue().district || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.province' | translate }}</div>
              @if (isEditing) {
                <input
                  [placeholder]="'page.customer.field.province' | translate"
                  autocomplete="off"
                  class="w-full"
                  formControlName="province"
                  pInputText
                />
              } @else {
                <div>{{ form.getRawValue().province || '-' }}</div>
              }
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.zip_code' | translate }}</div>
              @if (isEditing) {
                <p-input-number
                  [maxlength]="20"
                  [placeholder]="'page.customer.field.zip_code' | translate"
                  [useGrouping]="false"
                  class="w-full"
                  formControlName="zipCode"
                ></p-input-number>
              } @else {
                <div>{{ form.getRawValue().zipCode || '-' }}</div>
              }
            </div>

            <div class="col-span-1 sm:col-span-2">
              <div class="mb-2">{{ 'page.customer.field.note' | translate }}</div>
              @if (isEditing) {
                <textarea
                  [placeholder]="'page.customer.field.note' | translate"
                  class="w-full"
                  formControlName="note"
                  pTextarea
                  rows="5"
                ></textarea>
              } @else {
                <div>{{ form.getRawValue().note || '-' }}</div>
              }
            </div>
          </div>
        </form>
      </p-tabpanel>

      <p-tabpanel value="1">
        <form [formGroup]="formHealth">
          <div class="pt-8 grid grid-cols-2 lg:grid-cols-4 gap-y-8 gap-x-4">
            <div>
              <div class="mb-2">{{ 'page.customer.field.weight' | translate }}</div>
              <p-input-number
                [maxlength]="3"
                [useGrouping]="false"
                class="w-full"
                formControlName="weight"
              ></p-input-number>
            </div>

            <div>
              <div class="mb-2">{{ 'page.customer.field.height' | translate }}</div>
              <p-input-number
                [maxlength]="3"
                [useGrouping]="false"
                class="w-full"
                formControlName="height"
              ></p-input-number>
            </div>

            <div class="col-span-2 lg:col-span-4">
              <div class="mb-2">{{ 'page.customer.field.drug_allergy' | translate }}</div>
              <textarea class="w-full" formControlName="drugAllergy" pTextarea rows="5"></textarea>
            </div>

            <div class="col-span-2 lg:col-span-4">
              <div class="mb-2">{{ 'page.customer.field.mental_health' | translate }}</div>
              <textarea class="w-full" formControlName="mentalHealth" pTextarea rows="5"></textarea>
            </div>

            <div class="col-span-2 lg:col-span-4">
              <div class="mb-2">{{ 'page.customer.field.congenital_disease' | translate }}</div>
              <textarea class="w-full" formControlName="congenitalDisease" pTextarea rows="5"></textarea>
            </div>

            <div class="col-span-2 lg:col-span-4">
              <div class="mb-2">{{ 'page.customer.field.note' | translate }}</div>
              <textarea class="w-full" formControlName="healthNote" pTextarea rows="5"></textarea>
            </div>
          </div>
        </form>
      </p-tabpanel>

      <p-tabpanel value="2">
        <app-loading [loading]="loading"></app-loading>
        @if (!loading && checkOPDList) {
          <p-table [scrollable]="true" [value]="checkOPDList.content" scrollHeight="flex">
            <ng-template #header>
              <tr>
                <th style="min-width: 160px">{{ 'page.queue.label.doc_no' | translate }}</th>
                <th style="min-width: 200px">{{ 'common.label.status' | translate }}</th>
                <th style="min-width: 170px">{{ 'common.label.created' | translate }}</th>
                <th style="min-width: 170px">{{ 'common.label.updated' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-opd>
              <tr>
                <td (click)="goToView(opd.docNo)" class="text-primary cursor-pointer">
                  <b>{{ opd.docNo }}</b>
                </td>
                <td>
                  <p-tag
                    [severity]="calOPDStatus(opd.status)"
                    [value]="'common.options.check_opd.' + opd.status | translate"
                  />
                </td>
                <td>
                  {{ opd.created | date: 'dd/MM/yyyy HH:mm' }}
                </td>
                <td>
                  {{ opd.updated | date: 'dd/MM/yyyy HH:mm' }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td class="justify-items-center py-4" colspan="7">
                  <img alt="empty" class="pt-8" src="assets/images/no-data.png" width="100" />
                  <div class="pb-8 pt-8">
                    <b>{{ 'common.label.no_data' | translate }}</b>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        }
        @if (checkOPDList && checkOPDList.content.length > 0 && !loading) {
          <div class="flex justify-center mt-4">
            <p-paginator
              (onPageChange)="fetchData($event)"
              [first]="first"
              [rowsPerPageOptions]="[20, 50, 100]"
              [rows]="rows"
              [showCurrentPageReport]="true"
              [showJumpToPageDropdown]="false"
              [totalRecords]="checkOPDList.total"
              currentPageReportTemplate="{first} to {last}"
            />
          </div>
        }
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  @if (showFooter) {
    <div class="sticky dialog-footer">
      @if (isEditing) {
        <div class="flex justify-end gap-2">
          <p-button
            (click)="onSave()"
            [disabled]="isSaving"
            [label]="'common.button.save' | translate"
            [loading]="isSaving"
            appPreventDoubleClick
            class="btn-primary"
          ></p-button>
          <p-button (click)="onCancel()" [label]="'common.button.cancel' | translate" severity="secondary"></p-button>
        </div>
      } @else {
        <div class="flex justify-end gap-2">
          <p-button
            (click)="onEdit()"
            [label]="'common.button.edit' | translate"
            class="btn-primary"
            severity="warn"
          ></p-button>
        </div>
      }
    </div>
  }
}
